import { type Common } from './common.js';
import { type InsuranceProvider, type UpdateValues } from './models/insuranceProvider.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(name: string): Promise<InsuranceProvider> {
    const url = this.common.constructPath('/insurance-providers');
    const { insuranceProvider } = await this.common.postJSON(url, { name });
    return insuranceProvider;
  }

  async findOneById(id: string): Promise<InsuranceProvider> {
    const url = this.common.constructPath(`/insurance-providers/${id}`);
    const { insuranceProvider } = await this.common.getJSON(url);
    return insuranceProvider;
  }

  async findAll(): Promise<InsuranceProvider[]> {
    const url = this.common.constructPath(`/insurance-providers`);
    const { insuranceProviders } = await this.common.getJSON(url);
    return insuranceProviders;
  }

  async update(id: string, values: UpdateValues): Promise<InsuranceProvider> {
    const url = this.common.constructPath(`/insurance-providers/${id}`);
    const { insuranceProvider } = await this.common.putJSON(url, values);
    return insuranceProvider;
  }
}
